/* Calunar — Shopifys Cookie-Banner und -Dialog nachbessern:
   1. "Alle ablehnen" aus der Kopfzeile ans Ende der Einstellungen setzen.
   2. Den Link "Datenschutzerklärung" auf die gestaltete Page statt auf
      /policies/privacy-policy zeigen lassen. Die Adresse kommt aus
      data-datenschutz am Script-Tag in layout/theme.liquid.
   Shopify baut Banner und Dialog per Skript und teils bei jedem Oeffnen neu,
   deshalb ein MutationObserver. Der Button wird verschoben, nicht kopiert,
   damit Shopifys Klick-Handler erhalten bleibt. */
(() => {
  const FOOT_CLASS = 'cal-cookie-foot';
  const DATENSCHUTZ_URL = document.currentScript?.dataset.datenschutz || '';

  function moveDecline() {
    const dialog = document.getElementById('shopify-pc__prefs__dialog');
    if (!dialog) return;
    const decline = dialog.querySelector('#shopify-pc__prefs__header-decline');
    const scrollable = dialog.querySelector('.shopify-pc__prefs__scrollable');
    if (!decline || !scrollable) return;
    if (decline.closest('.' + FOOT_CLASS)) return; // schon unten

    let foot = scrollable.querySelector('.' + FOOT_CLASS);
    if (!foot) {
      foot = document.createElement('div');
      foot.className = FOOT_CLASS;
      scrollable.appendChild(foot);
    }
    foot.appendChild(decline);
  }

  function linkDatenschutz() {
    if (!DATENSCHUTZ_URL) return;
    document
      .querySelectorAll('[id^="shopify-pc"] a[href*="/policies/privacy-policy"]')
      .forEach((link) => link.setAttribute('href', DATENSCHUTZ_URL));
  }

  const nachbessern = () => {
    moveDecline();
    linkDatenschutz();
  };

  // Nur wenn Elemente dazukommen: Der Countdown der Ankuendigungsleiste tauscht
  // jede Sekunde nur Text aus. Beobachtet wird nur childList, das Umschreiben von
  // href loest also keinen neuen Durchlauf aus.
  const neueElemente = (mutations) =>
    mutations.some((m) => [...m.addedNodes].some((node) => node.nodeType === Node.ELEMENT_NODE));
  const observer = new MutationObserver((mutations) => {
    if (neueElemente(mutations)) nachbessern();
  });
  const start = () => {
    observer.observe(document.body, { childList: true, subtree: true });
    nachbessern();
  };
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
